import { masker as maskerHelper, mapToNumeric as mapToNumericHelper } from '@convenia/helpers'

/**
 * @deprecated Use `mapToNumeric` from `@convenia/helpers` instead. Kept as a
 * re-export for backward compatibility and will be removed in a future version.
 */
export const mapToNumeric = mapToNumericHelper

/**
 * @deprecated Use `masker` from `@convenia/helpers` instead. Kept as a re-export
 * for backward compatibility and will be removed in a future version.
 */
export const masker = maskerHelper

export const phoneMasker = (value) => {
  const digits = mapToNumeric(value)

  return masker(digits.length === 11 ? '(##) #####-####' : '(##) ####-####', digits)
}
